// extracted by mini-css-extract-plugin
export default {"archiveButton":"organization-table-cell__archive-button__h9Yi0"};